import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Phuluc5table from "components/Tonghopvantai/Phuluc5table.js";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";
const Phuluc5 = React.memo(function Phuluc5(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [data, setData] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/BaoCao/bcphuluc05qd342025?thangnam=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setData(data);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  return (
    <GridContainer>
      <GridItemLogin xs={12} sm={12} md={1}></GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={10}>
        <GridContainer style={{ border: "0.1px solid #4f7edb" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%" }}>
              <a className={classes.tieudecenter}>PHỤ LỤC 5</a>
              <a className={classes.tieudecenter}>
                MẪU SẢN LƯỢNG HÀNH KHÁCH, KHỐI LƯỢNG HÀNG HÓA VẬN CHUYỂN, LUÂN
                CHUYỂN BẰNG ĐƯỜNG BỘ VÀ ĐƯỜNG THỦY; TỔNG SẢN LƯỢNG HÀNG HÓA
                THÔNG QUA CÁC CẢNG BIỂN THÁNG
                {" " + String(thangnam.$M + 1).padStart(2, "0") + " "}
                NĂM {" " + thangnam.$y}
              </a>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Phuluc5table data={data} />
          </GridItem>
        </GridContainer>
      </GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={1}></GridItemLogin>
    </GridContainer>
  );
});

Phuluc5.propTypes = {
  thangnam: PropTypes.object,
};
export default Phuluc5;
